<template>
  <p>Estamos quase lá! Agora, preciso que você selecione as empresas para as quais deseja iniciar o controle de tarefas.</p>
  <br>
  <p><b>As tarefas serão vinculadas à(s) empresa(s) de acordo com o regime tributário. Certifique-se de que está correto.</b></p>
  <br>
  <div>
    <label>Pesquisar empresa</label>
    <TrfInput
      placeholder="Pesquise pelo nome, código ou regime tributário da empresa"
      v-model="filtro"
      maxLength="100"
      :required="false"
      @update:modelValue="() => throttle(filtrar, 300)"
    />

    <TrfSimpleTable
      :dados="tabela.filtradas"
      :isCliente="true"
      :isMultipleSelection="true"
      :configuracaoDeColunas="colunas"
      :checboxSelectAll="true"
      :alreadyCheckedItens="empresasSelecionadas"
      mensagemSemDados="Nenhuma empresa encontrada."
      @checkbox-change="setSelecionadas"
    />
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import { regimeTributario } from '../../enums/regimeTributarioEnum';
import { ordenacaoEnum } from '../../enums/ordenacaoEnum';

export default {
  name: "TrfWizardModuloEmpresas",
  components: {
    TrfInput: defineAsyncComponent(() => import('../Input/index.vue')),
    TrfSimpleTable: defineAsyncComponent(() => import('../../components/SimpleTable/index.vue'))
  },
  props: {
    empresas: {
      type: Array,
      default: new Array()
    },
    empresasSelecionadas: {
      type: Array,
      default: new Array()
    }
  },
  emits: ['update:empresasSelecionadas'],
  data() {
    return {
      filtro: "",
      tabela: {
        todas: this.empresas.map(this.getEmpresaObj),
        filtradas: []
      },
      colunas: [
        {
          titulo: "Código",
          referencia: ["externoId"],
          isSortable: true,
          sort: (ordenacao) => {
            this.tabela.filtradas = this.tabela.filtradas.sort((a, b) => {
                if(ordenacao == ordenacaoEnum.CRESCENTE) return a.externoId - b.externoId;
                return b.externoId - a.externoId;
            });
          }
        },
        {
          titulo: "Empresa",
          referencia: ["nome"],
          isSortable: true,
          sort: (ordenacao) => {
            this.tabela.filtradas = this.tabela.filtradas.sort((a, b) => {
                if(ordenacao == ordenacaoEnum.CRESCENTE) return ('' + a.nome).localeCompare(b.nome);
                return ('' + b.nome).localeCompare(a.nome);
            });
          }
        },
        {
          titulo: "Regime tributário",
          referencia: ["regimeTributario"],
          customStyle: "white-space:nowrap;",
          isSortable: true,
          sort: (ordenacao) => {
            this.tabela.filtradas = this.tabela.filtradas.sort((a, b) => {
              if(ordenacao == ordenacaoEnum.CRESCENTE) return ('' + a.regimeTributario).localeCompare(b.regimeTributario);
              return ('' + b.regimeTributario).localeCompare(a.regimeTributario);
            });
          }
        }
      ],
      isThrottling: false,
      isLoading: false
    };
  },
  methods: {
    filtrar() {
      this.tabela.filtradas = this.tabela.todas.filter(e => 
        e.nome.toLowerCase().includes(this.filtro.toLowerCase()) ||
        e.externoId.includes(this.filtro) ||
        e.regimeTributario.toLowerCase().includes(this.filtro.toLowerCase())
      );
    },
    getEmpresaObj(empresa) {
      const regimeTributarioEnum = regimeTributario.getById(empresa.attributes.regimeTributario);
      return {
          id: empresa.id,
          externoId: empresa.attributes.idExterno,
          nome: empresa.attributes.nome,
          regimeTributario: regimeTributarioEnum ? regimeTributarioEnum.nome : '- - -',
          showCheckboxDownload: true
        }
    },
    setSelecionadas(empresas) {
      this.$emit('update:empresasSelecionadas', empresas);
    },
    throttle(mainFunction, delay) {
      if (this.throttleId != null) {
        clearTimeout(this.throttleId);
      }

      this.throttleId = setTimeout(mainFunction, delay);
    }
  },
  created() {
    this.tabela.filtradas = this.tabela.todas;
  }
};
</script>

<style lang="scss" scoped>
</style>